<div class="search-outer-container" [ngClass]="isDialog ? 'in-dialog' : ''">
  <div class="search-container">
    @if ((loaded$ | async) === false && searchValue) {
      <div class="search-spinner-container">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    }
    @if ((loaded$ | async) || !searchValue) {
      <div class="icon-container search-icon" (click)="toggleFocus()">
        <gb-icon [icon]="'search'"></gb-icon>
      </div>
    }
    <div class="input-field-container">
      <input
        #input
        class="input-field"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [formControl]="searchFormControl"
        [style.width]="isDialog ? '100%' : ''"
      />
      <span class="input-hint" [translate]="label" [ngClass]="!focus && !searchValue ? 'visible' : 'hidden'"></span>
    </div>
    @if (searchValue) {
      <div class="icon-container clear-icon" (mousedown)="clearInput()" (touchstart)="clearInput()">
        <gb-icon [icon]="'close'"></gb-icon>
      </div>
    }
  </div>

  @if (filteredSearchHistory$ | async; as filteredSearchHistory) {
    <div [ngClass]="focus ? 'visible' : 'hidden'" class="search-history-container">
      @for (searchHistory of filteredSearchHistory; track searchHistory) {
        <div class="search-history" (click)="selectSearchHistory(searchHistory)">
          <gb-icon icon="search"></gb-icon>
          <div class="search-history-text gb-truncate" [innerHtml]="getSearchHistoryLabel(searchHistory)"></div>
        </div>
      }
      @if (filteredSearchHistory.length > 0) {
        <div class="clear-search-history-container">
          <span (click)="clearSearchHistory()" class="clear-search-history" translate="CLEAR_SEARCH_HISTORY"></span>
        </div>
      }
    </div>
  }
</div>
